import React from "react";
import { useSetPageTitle } from "@services/HeaderContext";


const Container = ({ children }) => {
    return (
        <div>{children}</div>
    );
};

const PageHeading = ({ title, centerComponent, rightComponent }) => {
    useSetPageTitle(title);

    return (
        <>
            <div className="mt-8 flex justify-between items-center ml-12 mr-12 mb-8 space-x-6 md:flex md:items-center h-[44px]">
                <div className="w-full min-w-[200px]">
                    <h1 className="text-3xl font-extrabold text-black truncate">
                        {title}
                    </h1>
                </div>

                {
                    centerComponent && <div className="flex items-center justify-center w-full min-w-[100px] max-w-[550px]">
                        {centerComponent}
                    </div>
                }

                <div className="flex space-x-5 flex-row items-left justify-left w-auto">
                    {rightComponent}
                </div>
            </div>
        </>
    );
};

const PageSection = ({ title, description, children }) => (
    <div className="mb-10 ml-9 mr-9">
        {title && (
            <>
                <div className="mb-1">
                    <div className="space-y-1">
                        <h3 className="text-lg leading-6 font-medium text-am-800">
                            {title}
                        </h3>
                        <p className="max-w-2xl text-sm text-gray-500">{description}</p>
                    </div>
                </div>
                <div className="mb-5">
                    <div className="w-full border-t border-gray-300" />
                </div>
            </>
        )}
        {children}
    </div>
);

export default Container;
export { Container, PageHeading, PageSection };
